import { createStyles } from 'antd-style';

import { absolute } from '../../styles/mixins';
import { hexToRgbaWithAlpha } from '../../theme';
import { blindedBlock } from './shipmentDetailShared.styles';

export const useShipmentDetailMapStyles = createStyles(({ token }) => ({
  blindedMap: {
    ...absolute(0),
    ...blindedBlock(token.fontSizeLG),
    backgroundColor: hexToRgbaWithAlpha(token.colorWhite, 0.35),
    backdropFilter: 'blur(2px)',
    justifyContent: 'center',

    '> span': {
      display: 'inline-block',
      width: 260,
      textAlign: 'center',
    },
  },
}));
